module.exports = __webpack_public_path__ + "static/media/about-us-hero.72441071.png";